import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../../header/header";
import { useDispatch, useSelector } from "react-redux";
import { getMultibaggerListServiceApi } from "../../../redux/portfolio/portfolio";
import moment from "moment";
import { APP_URL } from "../../../config/constants.config";

export default function Multibagger() {
  const userDetail = useSelector((state) => state.auth.userDetail);
  const portFolioList = useSelector((state) => state.portfolio.portFolioList);
  const userMultibaggerList = useSelector(
    (state) => state.portfolio.userMultibaggerData
  );
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Porfolio");
  const [showModal, setShowModal] = useState(false);
  const [stocks, setStocks] = useState(portFolioList);
  const modalRef = useRef(null);
  const shares = 10;
  const price = 256;
  const [selectedStockId, setSelectedStockId] = useState(null);

  const handleSave = () => {
    setShowModal(false);
    alert("hello");
  };
  useEffect(() => {
    // document.oncontextmenu = function () {
    //   return false;
    // };
    // const handleClickOutside = (event) => {
    //   if (modalRef.current && !modalRef.current.contains(event.target)) {
    //     setShowModal(false);
    //   }
    // };

    // if (showModal) {
    //   document.addEventListener("mousedown", handleClickOutside);
    // } else {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // }

    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, [showModal]);
  useEffect(() => {
    dispatch(getMultibaggerListServiceApi(userDetail?.id));
  }, []);
  const formatNumber = (num) => {
    return Number(num || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    const handleStorageChange = () => {
      setTheme(localStorage.getItem("theme") || "light");
    };

    // If you have a theme toggle function, you can call setTheme directly there
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const exitPriceCount = useMemo(() => {
    return userMultibaggerList?.dataList
      ?.filter(item => item.exitPrice)
      ?.reduce((total, stock) => total + (stock.overallPLVal || 0), 0);
  }, [userMultibaggerList?.dataList]);
  const { openCount, closedCount, totalCount } = useMemo(() => {
    return (userMultibaggerList?.dataList || []).reduce(
      (acc, item) => {
        if (item.exitPrice) {
          acc.closedCount += 1;
        } else {
          acc.openCount += 1;
        }
        acc.totalCount += 1;
        return acc;
      },
      { openCount: 0, closedCount: 0, totalCount: 0 }
    );
  }, [userMultibaggerList?.dataList]);
  return (
    <div>
      <Header />
      <div className="py-3 bg-body-tertiary" style={{ minHeight: "100vh" }}>
        <div className="container">
          {/* Header */}
          {/* <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-baseline">
              <h1 className="fs-4 fw-bold text-capitalize mb-0">
                🚀 Multibaggers
              </h1>
              <small className=" ms-2">
                ({userMultibaggerList?.dataList?.length || 0})
              </small>
            </div>
          </div> */}
          <div className="row g-3 justify-content-between">
            <div className="col-md-12">
              <div className="d-flex align-items-baseline">
                <h1 className="fs-4 fw-bold text-capitalize mb-0">
                  🚀 Multibaggers
                </h1>
                <small className=" ms-2 fw-semibold">
                  <small> ({userMultibaggerList?.dataList?.length} {userMultibaggerList?.dataList?.length > 1 ? "Stocks" : "Stock"}) </small>
                </small>
              </div>
            </div>
            <div className="col-md-auto col-6">
              <div>
                <small className="text-muted">Invested</small>
                <h5 className="fw-semibold">
                  ₹{formatNumber(userMultibaggerList?.meta?.invested)}
                </h5>
              </div>
            </div>
            <div className="col-md-auto col-6">
              <div>
                <small className="text-muted">Current Value</small>
                <h5 className="fw-semibold">
                  ₹{formatNumber(userMultibaggerList?.meta?.currentValue)}
                </h5>
              </div>
            </div>
            <div className="col-md-auto col-6">
              <div>
                <small className="text-muted">Current P&amp;L</small>
                <h5
                  className={`fw-semibold ${userMultibaggerList?.meta?.overallPLAmt > 0
                    ? "text-green"
                    : "text-red"
                    }`}
                >
                  ₹{formatNumber(userMultibaggerList?.meta?.overallPLAmt)}{" "}
                  <small className="">
                    ({formatNumber(userMultibaggerList?.meta?.overallPLPer)}%)
                  </small>
                </h5>
              </div>
            </div>
            <div className="col-md-auto col-6">
              <div>
                <small className="text-muted">Day's P&L</small>
                <h5
                  className={`fw-semibold ${userMultibaggerList?.meta?.todayGainAmt > 0
                    ? "text-green"
                    : "text-red"
                    }`}
                >
                  ₹{formatNumber(userMultibaggerList?.meta?.todayGainAmt)}{" "}
                  <small >
                    ({formatNumber(userMultibaggerList?.meta?.todayGainPer)}%)
                  </small>
                </h5>
              </div>
            </div>
            <div className="col-md-auto col-6">
              <div>
                <small className="text-muted">Total P&L</small>
                <h5
                  className={`fw-semibold ${userMultibaggerList?.meta?.overallPLAmt + exitPriceCount > 0
                    ? "text-green"
                    : "text-red"
                    }`}
                >
                  ₹{formatNumber(userMultibaggerList?.meta?.overallPLAmt + exitPriceCount)}{" "}
                  {/* <small >
                    ({formatNumber(userMultibaggerList?.meta?.todayGainPer)}%)
                  </small> */}
                </h5>
              </div>
            </div>
          </div>
          {/* Table */}
          <h5
            className={`fw-semibold mt-4`}
          >

            <small className="">Open <small> <small> ({openCount} {openCount > 1 ? "Stocks" : "Stock"}) </small> </small></small>
          </h5>

          <div className="table-responsive mt-md-1 mt-1">
            <table
              className="table align-middle mb-0 border border-secondary rounded-2 overflow-hidden"
              style={{
                borderCollapse: "separate",
                borderSpacing: 0,
                "--bs-border-opacity": 0.3,
                fontSize: "14px",
              }}
            >
              {/* ===== TABLE HEADER (ALWAYS VISIBLE) ===== */}
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 5,
                  backgroundColor: "#1e1e1e",
                }}
              >
                <tr>
                  <th className="text-start text-muted small fw-normal">Scrip</th>
                  <th className="text-end text-muted small fw-normal">Recom Date</th>
                  <th className="text-end text-muted small fw-normal">Recom Price</th>
                  <th className="text-end text-muted small fw-normal">LTP</th>
                  <th className="text-end text-muted small fw-normal">Qty</th>
                  <th className="text-end text-muted small fw-normal">Invested</th>
                  <th className="text-end text-muted small fw-normal">Cur. Val</th>
                  <th className="text-end text-muted small fw-normal">Current P&amp;L</th>
                  <th className="text-end text-muted small fw-normal">Day's P&amp;L</th>
                  <th className="text-end text-muted small fw-normal">View Report</th>
                </tr>
              </thead>

              {/* ===== TABLE BODY ===== */}
              <tbody>
                {userMultibaggerList?.dataList?.length > 0 ? (
                  userMultibaggerList.dataList?.filter((item) => !item.exitPrice)?.map((stock, idx) => (
                    <tr key={idx} style={{ backgroundColor: "#121212" }}>
                      <td className="text-start py-3">
                        <div className="fw-semibold body-emphasis">{stock.symbol}</div>
                        <small className="text-muted">{stock.name}</small>
                      </td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        {moment(stock.recomandedDate).format("D MMM YYYY")}
                      </td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        ₹{formatNumber(stock.recomPrice)}
                      </td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        ₹{formatNumber(stock.ltp)}
                      </td>

                      <td className="text-end" style={{ minWidth: "50px" }}>{stock.qty}</td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        ₹{formatNumber(stock.invested)}
                      </td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        ₹{formatNumber(stock.currentVal)}
                      </td>

                      <td
                        style={{ minWidth: "100px" }}
                        className={`text-end ${stock.overallPLVal < 0 ? "text-red" : "text-green"
                          }`}
                      >
                        ₹{formatNumber(stock.overallPLVal)}{" "}
                        <small>({formatNumber(stock.overallPLPer)}%)</small>
                      </td>

                      <td
                        style={{ minWidth: "100px" }}
                        className={`text-end ${stock.todayPLVal < 0 ? "text-red" : "text-green"
                          }`}
                      >
                        ₹{formatNumber(stock.todayPLVal)}{" "}
                        <small>({formatNumber(stock.todayPLPer)}%)</small>
                      </td>

                      <td className="text-end" style={{ cursor: "pointer", minWidth: "80px" }}>
                        <a
                          onClick={() => setSelectedStockId(stock?.id)}
                          className="nav-link p-0 uni-cursor-pointer"
                        >
                          <small className="text-primary nav-underline">View</small>
                        </a>

                        {selectedStockId === stock?.id && (
                          <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-xl modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    {`${stock?.symbol} report`}
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setSelectedStockId(null)}
                                  ></button>
                                </div>

                                <div
                                  className="modal-body"
                                  style={{ height: "80vh" }}
                                >
                                  <iframe
                                    src={`${stock?.multibaggerReportPath}#toolbar=0&navpanes=0&scrollbar=0`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      border: "none",
                                    }}
                                    title={`${stock.name} report`}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  /* ===== NO DATA ROW ===== */
                  <tr>
                    <td
                      colSpan={10}
                      className="text-center text-muted py-5"
                    // style={{ backgroundColor: "#121212" }}
                    >
                      Multibagger Recommendations will be displayed here.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* closed */}
          <div className="d-flex justify-content-between mt-5">

            <h5
              className={`fw-semibold `}
            >
              <small className="">Closed <small> <small> ({closedCount} {closedCount > 1 ? "Stocks" : "Stock"}) </small> </small></small>
            </h5>
            <div>
              <div className="d-flex gap-2">
                <h5 className="text-muted">Total Booked P&L:</h5>
                <h5
                  className={`fw-semibold ${exitPriceCount > 0
                    ? "text-green"
                    : exitPriceCount < 0
                      ? "text-red"
                      : "text-black"
                    }`}

                >
                  ₹{formatNumber(exitPriceCount)}{" "}
                  {/* <small >
                    ({formatNumber(userMultibaggerList?.meta?.todayGainPer)}%)
                  </small> */}
                </h5>
              </div>
            </div>
          </div>
          <div className="table-responsive mt-md-1 mt-2">
            <table
              className="table align-middle mb-0 border border-secondary rounded-2 overflow-hidden"
              style={{
                borderCollapse: "separate",
                borderSpacing: 0,
                "--bs-border-opacity": 0.3,
                fontSize: "14px",
              }}
            >
              {/* ===== TABLE HEADER (ALWAYS VISIBLE) ===== */}
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 5,
                  backgroundColor: "#1e1e1e",
                }}
              >
                <tr>
                  <th className="text-start text-muted small fw-normal">Scrip</th>
                  <th className="text-end text-muted small fw-normal">Recom Date</th>
                  <th className="text-end text-muted small fw-normal">Recom Price</th>
                  {/* <th className="text-end text-muted small fw-normal">LTP</th> */}
                  <th className="text-end text-muted small fw-normal">Qty</th>
                  <th className="text-end text-muted small fw-normal">Exit Price</th>
                  <th className="text-end text-muted small fw-normal">Exit Date</th>
                  {/* <th className="text-end text-muted small fw-normal">Invested</th> */}
                  {/* <th className="text-end text-muted small fw-normal">Cur. Val</th> */}
                  <th className="text-end text-muted small fw-normal">Booked P&amp;L</th>
                  {/* <th className="text-end text-muted small fw-normal">Today Gain</th> */}
                  <th className="text-end text-muted small fw-normal">View Report</th>
                </tr>
              </thead>

              {/* ===== TABLE BODY ===== */}
              <tbody>
                {userMultibaggerList?.dataList?.length > 0 ? (
                  userMultibaggerList.dataList?.filter((item) => item.exitPrice)?.map((stock, idx) => (
                    <tr key={idx} style={{ backgroundColor: "#121212" }}>
                      <td className="text-start py-3" style={{ minWidth: "100px" }}>
                        <div className="fw-semibold body-emphasis">{stock.symbol}</div>
                        <small className="text-muted">{stock.name}</small>
                      </td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        {moment(stock.recomandedDate).format("D MMM YYYY")}
                      </td>

                      <td className="text-end" style={{ minWidth: "100px" }}>
                        ₹{formatNumber(stock.recomPrice)}
                      </td>

                      {/* <td className="text-end">
                        ₹{formatNumber(stock.ltp)}
                      </td> */}

                      <td className="text-end" style={{ minWidth: "50px" }}>{stock.qty}</td>
                      <td className="text-end" style={{ minWidth: "100px" }}>{stock.exitPrice}</td>
                      <td className="text-end" style={{ minWidth: "100px" }}>{moment(stock.bookedAt).format("D MMM YYYY")}</td>
                      {/* <td className="text-end">
                        ₹{formatNumber(stock.invested)}
                      </td> */}

                      {/* <td className="text-end">
                        ₹{formatNumber(stock.currentVal)}
                      </td> */}

                      <td
                        style={{ minWidth: "100px" }}
                        className={`text-end ${stock.overallPLVal < 0 ? "text-red" : "text-green"
                          }`}
                      >
                        ₹{formatNumber(stock.overallPLVal)}{" "}
                        <small>({formatNumber(stock.overallPLPer)}%)</small>
                      </td>

                      {/* <td
                        className={`text-end ${stock.todayPLVal < 0 ? "text-red" : "text-green"
                          }`}
                      >
                        ₹{formatNumber(stock.todayPLVal)}{" "}
                        <small>({formatNumber(stock.todayPLPer)}%)</small>
                      </td> */}

                      <td className="text-end" style={{ cursor: "pointer", minWidth: "100px" }}>
                        <a
                          onClick={() => setSelectedStockId(stock?.id)}
                          className="nav-link p-0 uni-cursor-pointer"
                        >
                          <small className="text-primary nav-underline">View</small>
                        </a>

                        {selectedStockId === stock?.id && (
                          <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-xl modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    {`${stock?.symbol} report`}
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setSelectedStockId(null)}
                                  ></button>
                                </div>

                                <div
                                  className="modal-body"
                                  style={{ height: "80vh" }}
                                >
                                  <iframe
                                    src={`${stock?.multibaggerReportPath}#toolbar=0&navpanes=0&scrollbar=0`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      border: "none",
                                    }}
                                    title={`${stock.name} report`}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  /* ===== NO DATA ROW ===== */
                  <tr>
                    <td
                      colSpan={10}
                      className="text-center text-muted py-5"
                    // style={{ backgroundColor: "#121212" }}
                    >
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  );
}
